// frontend/src/services/eventService.js
// Event management operations
import { supabase } from './supabaseCore';

// Create a new event
export const createEvent = async (eventData) => {
    try {
        const insertData = {
            code: eventData.code,
            name: eventData.name,
            short_name: eventData.shortName,
            start_date: eventData.startDate,
            end_date: eventData.endDate,
            location: eventData.location
        };
        // Add thumbnail_url if provided
        if (eventData.thumbnailUrl) {
            insertData.thumbnail_url = eventData.thumbnailUrl;
        }

        const { data, error } = await supabase
            .from('events')
            .insert([insertData])
            .select()
            .single();

        if (error) throw error;
        return { data, error: null };
    } catch (error) {
        console.error('Error creating event:', error);
        return { data: null, error };
    }
};

// Get all events (detailed list for admin)
export const getAllEvents = async () => {
    try {
        const { data, error } = await supabase
            .from('events')
            .select('*')
            .order('start_date', { ascending: false });

        if (error) throw error;
        return { data, error: null };
    } catch (error) {
        console.error('Error fetching events:', error);
        return { data: null, error };
    }
};

// Toggle event archive status
export const toggleEventArchiveStatus = async (eventId, isArchived) => {
    try {
        const { data, error } = await supabase
            .from('events')
            .update({ is_archived: isArchived })
            .eq('id', eventId)
            .select()
            .single();

        if (error) throw error;
        return { data, error: null };
    } catch (error) {
        console.error('Error updating event archive status:', error);
        return { data: null, error };
    }
};

// Update event metadata (name, dates, location, thumbnail - NOT code or short_name)
export const updateEvent = async (eventId, eventData) => {
    try {
        const updateFields = {};
        if (eventData.name !== undefined) updateFields.name = eventData.name;
        if (eventData.startDate !== undefined) updateFields.start_date = eventData.startDate;
        if (eventData.endDate !== undefined) updateFields.end_date = eventData.endDate;
        if (eventData.location !== undefined) updateFields.location = eventData.location;
        if (eventData.thumbnailUrl !== undefined) updateFields.thumbnail_url = eventData.thumbnailUrl;

        const { data, error } = await supabase
            .from('events')
            .update(updateFields)
            .eq('id', eventId)
            .select()
            .single();

        if (error) throw error;
        return { data, error: null };
    } catch (error) {
        console.error('Error updating event:', error);
        return { data: null, error };
    }
};

// Upload event thumbnail image
export const uploadEventThumbnail = async (eventId, file) => {
    try {
        const timestamp = Date.now();
        const fileName = `event-thumbnails/${eventId}_${timestamp}.jpg`;

        const { error: storageError } = await supabase.storage
            .from('player-photos')
            .upload(fileName, file, {
                contentType: file.type || 'image/jpeg',
                upsert: true
            });

        if (storageError) throw storageError;

        const { data: { publicUrl } } = supabase.storage
            .from('player-photos')
            .getPublicUrl(fileName);

        return { url: publicUrl, error: null };
    } catch (error) {
        console.error('Error uploading thumbnail:', error);
        return { url: null, error };
    }
};
